import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageSize: 15,
  currentPage: 1,
  url: `/seslog/`,
  filter_flag: false,
  search: "",
  filters: "",
  itemsLength: 0,
  activeRedux: true,
  sort_column: "",
  sort_order: "",
  newPageSize: 15,
  email_status: "",
  l1filters: [],
  l2filters: [],
  l3filters: [],
  selectedl1filters : 0,
  selectedl2filters : 0,
  selectedl3filters : 0,
  l1name: "",  // Added l1name
  l2name: "",  // Added l2name
  l3name: "",   // Added l3name
  event_type : "",
};

const emailfilterSlice = createSlice({
  name: "emailfilter",
  initialState,
  reducers: {
    setEmailFilterDataRedux: (state, action) => {
      const {
        pageSize,
        currentPage,
        url,
        filter_flag,
        search,
        filters,
        itemsLength,
        activeRedux,
        sort_column,
        sort_order,
        newPageSize,
        email_status,
        l1name,
        l2name,
        l3name,
        l1filters,
        l2filters,
        l3filters,
        event_type,
        selectedl1filters,
        selectedl2filters,
        selectedl3filters
      } = action.payload;

      // Update state with new filter values
      state.pageSize = pageSize ?? state.pageSize;
      state.currentPage = currentPage ?? state.currentPage;
      state.url = url ?? state.url;
      state.filter_flag = filter_flag ?? state.filter_flag;
      state.search = search ?? state.search;
      state.filters = filters ?? state.filters;
      state.activeRedux = activeRedux ?? state.activeRedux;
      state.sort_column = sort_column ?? state.sort_column;
      state.sort_order = sort_order ?? state.sort_order;
      state.newPageSize = newPageSize ?? state.newPageSize;
      state.email_status = email_status ?? state.email_status;
      state.l1filters = l1filters ?? state.l1filters;
      state.l2filters = l2filters ?? state.l2filters;
      state.l3filters = l3filters ?? state.l3filters;
      state.selectedl1filters = selectedl1filters ?? state.selectedl1filters;
      state.selectedl2filters = selectedl2filters ?? state.selectedl2filters;
      state.selectedl3filters = selectedl3filters ?? state.selectedl3filters;
      state.l1name = l1name ?? state.l1name;
      state.l2name = l2name ?? state.l2name;
      state.l3name = l3name ?? state.l3name;
      state.event_type = event_type ?? state.event_type;

      // Update items length
      state.itemsLength = itemsLength ?? state.itemsLength;
    },
  },
});

export const { setEmailFilterDataRedux } = emailfilterSlice.actions;
export default emailfilterSlice.reducer;
